import { Editor } from 'grapesjs';
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage';
import { getLocalizedProperty } from '@loyalty/shared-common';
import { EditorComponentDefinition } from './types';
import { ImageWidgetTraits } from './image/ImageWidgetTraits';
import { Toolbar } from '../utils';
import { translateAttributes } from '../../services/copy-paste/copy-paste-utils';
import { updateI18nAttributes } from './i18n';

export const imageComponentDefinition: EditorComponentDefinition = {
  id: 'image',
  icon: faImage,
  category: 'Content',
  getLabel: ({ t }) => t('editor.component.image'),
  component: ImageComponent,
  copyPasteHelper: (element, context) => translateAttributes(element, context.destinationLocales),
  traits: {
    form: ImageWidgetTraits,
  },
};

export function ImageComponent(editor: Editor) {
  const i18n = editor.I18n;

  editor.DomComponents.addType(imageComponentDefinition.id, {
    extend: 'image',
    model: {
      initToolbar: Toolbar,
      defaults: {},
    },
    view: {
      init({ model }: { model: any }) {
        this.listenTo(model, 'component:update:src', () => {
          const { src } = this.model.attributes.attributes;
          updateI18nAttributes.call(this, i18n.getLocale(), { src });
        });
      },
      onRender() {
        const { i18nAttributes = {} } = this.model.attributes;
        const locale = i18n.getLocale();
        const value = getLocalizedProperty({ i18nAttributes }, 'src', locale);
        this.el.src = value;
      },
    },
  });
}
